import { useCallback, useEffect, useState, Fragment } from "react";
import CategoryCard from "components/category";
import { useNavigate, useParams } from "react-router-dom";
import { StyledStack, ButtonContainer, StyledTitle } from "./AddDesign.style";
import { useForm } from "react-hook-form";
import { Link } from "react-router-dom";
import { yupResolver } from "@hookform/resolvers/yup";
import BackButton from "components/shared/BackButton";
import CheckIcon from "@mui/icons-material/Check";
import DrawerCM from "components/shared/Drawer";
import Toast from "helper/toast";
import LoadingCM from "components/shared/Loading";
import useHttp from "hooks/use-http";
import { CategorySchema } from "validations";
import { addDesignRequest, getDesignRequest } from "api/requests";
import { Grid, Button, TextField, IconButton } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import { PAGINATION_LIMIT } from "constants";
import PaginationCM from "components/shared/Pagination";
import TableCM from "components/shared/Table";
import GenarateHeadCell from "helper/generate-head-cell";

const headCells = GenarateHeadCell("design");

export default function AddCategory() {
  const params = useParams();
  const { request, loading } = useHttp(false);
  const [design, setDesign] = useState({ data: [], count: 0 });
  const [page, setPage] = useState(1);
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(CategorySchema),
  });

  const onSubmit = async (values) => {
    const transformedData = {
      title: values.title,
      category_id: params.categoryId,
    };
    const res = await request({
      url: addDesignRequest,
      values: transformedData,
    });

    if (res) {
      reset({
        title: "",
      });
      Toast({ type: "success", title: "ثبت طرح" });
      getDesign();
    }
  };

  const getDesign = useCallback(async () => {
    const res = await request({
      url: getDesignRequest,
      values: {
        skip: (page - 1) * PAGINATION_LIMIT,
        limit: PAGINATION_LIMIT,
        category_id: params.categoryId,
      },
    });

    let transformedData = res.data.map((items) => ({
      id: items.id,
      title: items.title,
      edit: (
        <Link to={`/design/${items.id}`}>
          <IconButton color="primary">
            <EditIcon />
          </IconButton>
        </Link>
      ),
    }));

    setDesign({ data: transformedData, count: res.count });
  }, [page, request]);

  useEffect(() => {
    getDesign();
  }, [page, getDesign]);

  // console.log(design && design.data.title);

  return (
    <DrawerCM title="افزودن طرح">
      {loading ? (
        <LoadingCM />
      ) : (
        <Grid container my={2}>
          <Grid item mt={3} xs={12}>
            <BackButton />
          </Grid>
          <StyledStack>
            <StyledTitle>افزودن طرح</StyledTitle>
            <Grid container>
              <Grid item md={12} xs={12} p={1.5}>
                <TextField
                  label="عنوان"
                  variant="outlined"
                  fullWidth
                  id="title"
                  {...register("title")}
                  error={Boolean(errors.title)}
                  helpertext={errors.title?.message}
                />
              </Grid>
              <ButtonContainer>
                <Button
                  startIcon={<CheckIcon />}
                  variant="contained"
                  sx={{ mt: 1 }}
                  onClick={handleSubmit(onSubmit)}
                >
                  ذخیره
                </Button>
              </ButtonContainer>
            </Grid>
          </StyledStack>
          <Grid item xs={12} my={2}>
            <TableCM
              title="طرح ها"
              rows={design.data}
              headCells={headCells}
              page={page}
            />
          </Grid>
          {design.data.length > 0 ? (
            <PaginationCM
              handleChange={(e, val) => setPage(val)}
              page={page}
              count={design.count}
            />
          ) : (
            " "
          )}
        </Grid>
      )}
    </DrawerCM>
  );
}
